/**
 * TanStack Query hooks for `bigcommerce-integration-via-webhook`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	bigcommerceIntegrationViaWebhookQueryKeys,
	listEvents,
	rotateSecret,
	type ListEventsResponse,
	type RotateSecretResult,
} from "./api";

export function useBigcommerceIntegrationViaWebhookEvents(
	limit = 50,
): UseQueryResult<ListEventsResponse, Error> {
	return useQuery({
		queryKey: [
			...bigcommerceIntegrationViaWebhookQueryKeys.events(),
			limit,
		],
		queryFn: () => listEvents(limit),
	});
}

export function useBigcommerceIntegrationViaWebhookRotateSecret(): UseMutationResult<
	RotateSecretResult,
	Error,
	void
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: () => rotateSecret(),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: bigcommerceIntegrationViaWebhookQueryKeys.all,
			});
		},
	});
}
